module.exports = __webpack_public_path__ + "site/img/265.75f5f194.jpg";